import GeneralInfos from "@modules/plaintes/complaintManaging/addingComplaint/step1/generalInfos.tsx";
import ComplainantInfos from "@modules/plaintes/complaintManaging/addingComplaint/step2/complainantInfos.tsx";
import ComplaintMotif from "@modules/plaintes/complaintManaging/addingComplaint/step4/complaintMotif.tsx";
import CaseDetail from "@modules/plaintes/complaintManaging/addingComplaint/step3/caseDetail.tsx";
import MeasureToBeTaken from "@modules/plaintes/complaintManaging/addingComplaint/step5/measuresToBeTaken.tsx";
import { Steps } from "primereact/steps";
import { useEffect, useState } from "react";
import ConcernedPerson from "./step2/concernedPerson.tsx";
import ComplaintType from "./step5/ComplaintType.tsx";
import AgressorInfos from "./step6/agressorInfos.tsx";
import Signature from "./step7/signature.tsx";

const AddComplaint = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isResolvedComplaint, setIsResolvedComplaint] = useState(true);
  const [activeIndexStep2, setActiveIndexStep2] = useState(0);

  const [visitedSteps1, setVisitedSteps1] = useState<number[]>([0]);

  const handleStepChange = (index: number) => {
    if (visitedSteps1.includes(index)) {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    if (!isResolvedComplaint) {
      setActiveIndexStep2(0);
    }
  }, [isResolvedComplaint]);

  const handleNextStep = () => {
    if (isResolvedComplaint) {
      setActiveIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        setVisitedSteps1((prevSteps) =>
          prevSteps.includes(nextIndex) ? prevSteps : [...prevSteps, nextIndex]
        );
        return nextIndex;
      });
    } else {
      if (activeIndexStep2 < steps2.length - 1) {
        setActiveIndexStep2((prevIndex) => prevIndex + 1);
      }
    }
  };

  const handlePreviousStep = () => {
    if (isResolvedComplaint) {
      if (activeIndex > 0) {
        setActiveIndex((prevIndex) => prevIndex - 1);
      }
    } else {
      if (activeIndexStep2 > 0) {
        setActiveIndexStep2((prevIndex) => prevIndex - 1);
      }
    }
  };

  const handleResolveComplaint = (value: boolean) => {
    setIsResolvedComplaint(value);
  };

  const steps = [
    { label: "Référencement de la plainte" },
    { label: "Informations sur le plaignant" },
    { label: "Détails du Cas" },
    { label: "Cause de la plainte" },
    { label: "Mesure à prendre" },
  ];

  const steps2 = [
    { label: "Référencement de la plainte" },
    { label: "Informations sur le plaignant" },
    { label: "Informations sur la victime" },
    { label: "Détails du Cas" },
    { label: "Type de la plainte" },
    { label: "Information sur le présumé auteur" },
    { label: "Mesure à prendre" },
  ];

  return (
    <div className="column gap-[40px] container my-auto mt-5">
      {isResolvedComplaint && (
        <>
          <Steps
            model={steps}
            activeIndex={activeIndex}
            onSelect={(e) => handleStepChange(e.index)}
            className="my-custom-steps1"
            readOnly={true}
          />
          <div className="column gap-[20px] h-12rem p-8 bg-white rounded-lg">
            {activeIndex === 0 && (
              <GeneralInfos
                onNext={handleNextStep}
                isResolvedComplaint={isResolvedComplaint}
              />
            )}
            {activeIndex === 1 && (
              <ComplainantInfos
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
                isResolvedComplaint={isResolvedComplaint}
              />
            )}
            {activeIndex === 2 && (
              <CaseDetail
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}
            {activeIndex === 3 && (
              <ComplaintMotif
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}
            {activeIndex === 4 && (
              <MeasureToBeTaken
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
                onResolve={handleResolveComplaint}
              />
            )}
          </div>
        </>
      )}
      {!isResolvedComplaint && (
        <>
          <Steps
            model={steps2}
            activeIndex={activeIndexStep2}
            onSelect={(e) => setActiveIndexStep2(e.index)}
            className="my-custom-steps2"
            readOnly={true}
          />

          <div className="column gap-[20px] h-12rem card-stepper p-8 bg-white rounded-lg">
            {activeIndexStep2 === 0 && (
              <GeneralInfos
                onNext={handleNextStep}
                isResolvedComplaint={isResolvedComplaint}
              />
            )}
            {activeIndexStep2 === 1 && (
              <ComplainantInfos
                isResolvedComplaint={isResolvedComplaint}
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}
            {activeIndexStep2 === 2 && (
              <ConcernedPerson
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}
            {activeIndexStep2 === 3 && (
              <CaseDetail
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
                isResolvedComplaint={isResolvedComplaint}
              />
            )}
            {activeIndexStep2 === 4 && (
              <ComplaintType
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}

            {activeIndexStep2 === 5 && (
              <AgressorInfos
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}
            {activeIndexStep2 === 6 && (
              <Signature
                onNext={handleNextStep}
                onPrevious={handlePreviousStep}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AddComplaint;
